import { render } from "./ColorButton.vue?vue&type=template&id=39016b60&scoped=true&ts=true"
import script from "./ColorButton.vue?vue&type=script&lang=ts"
export * from "./ColorButton.vue?vue&type=script&lang=ts"

import "./ColorButton.vue?vue&type=style&index=0&id=39016b60&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39016b60"]])

export default __exports__